import { render } from "./BeneficiariesView.vue?vue&type=template&id=39c8fc1a&scoped=true"
import script from "./BeneficiariesView.vue?vue&type=script&lang=js"
export * from "./BeneficiariesView.vue?vue&type=script&lang=js"

import "./BeneficiariesView.vue?vue&type=style&index=0&id=39c8fc1a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c8fc1a"]])

export default __exports__